/**
 * The dash chrome's icon set, drawn inline.
 *
 * Replaces five FontAwesome glyphs that were rendered as icon-only circles
 * with `title` attributes for meaning. These are stroked at a weight that
 * matches the engraved rules used elsewhere, and inherit `currentColor`
 * so a single hover rule colours icon and label together.
 */

const Svg = ({ children }) => (
    <svg
        className="dash-nav__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
)

export const UsersIcon = () => (
    <Svg>
        <circle cx="9" cy="8" r="3.4" />
        <path d="M3.2 19.4a5.9 5.9 0 0 1 11.6 0" />
        <path d="M16.6 5.2a3.4 3.4 0 0 1 0 5.6" />
        <path d="M17.6 14.4a5.9 5.9 0 0 1 3.2 5" />
    </Svg>
)

export const UserPlusIcon = () => (
    <Svg>
        <circle cx="9.5" cy="8" r="3.4" />
        <path d="M3.5 19.4a6 6 0 0 1 12 0" />
        <path d="M18.5 9v6M15.5 12h6" />
    </Svg>
)

export const LogoutIcon = () => (
    <Svg>
        <path d="M14 4.5H6.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H14" />
        <path d="M17 8.5 20.5 12 17 15.5" />
        <path d="M20 12h-9" />
    </Svg>
)

export const HomeIcon = () => (
    <Svg>
        <path d="M3.8 10.6 12 4l8.2 6.6" />
        <path d="M5.8 9.9v9.2h12.4V9.9" />
        <path d="M9.9 19.1v-5.2h4.2v5.2" />
    </Svg>
)
